﻿import * as paths from '../utils/paths';

export default class GeneralActionSettingsHandler {
    constructor(rootURL, mapId) {
        this.rootURL = rootURL;
        this.mapId = mapId;
        this.settings = {};
    }

    load() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_GENERAL_ACTIONS_SETTINGS_URL + this.mapId,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this.settings = result;
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }
}